import React from 'react';

var StrokeLogo = function StrokeLogo() {
  return (
    /* @__PURE__ */
    React.createElement("svg", {
      width: 42,
      height: 42,
      viewBox: "0 0 42 42"
    },
    /* @__PURE__ */
    React.createElement("g", {
      stroke: "currentColor",
      strokeWidth: 1.5,
      fill: "none",
      fillRule: "evenodd"
    },
    /* @__PURE__ */
    React.createElement("path", {
      d: "M31.5 21c0 7.871-6.379 14.25-14.25 14.25S3 28.871 3 21 9.379 6.75 17.25 6.75 31.5 13.129 31.5 21z"
    }),
    /* @__PURE__ */
    React.createElement("path", {
      d: "M39 21c0 7.871-6.379 14.25-14.25 14.25S10.5 28.871 10.5 21 16.879 6.75 24.75 6.75 39 13.129 39 21z"
    })))
  );
};

export { StrokeLogo };